'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Ad = require('../Ad/Ad');

var _Ad2 = _interopRequireDefault(_Ad);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ClientPlacedAd = function ClientPlacedAd(_ref) {
    var _ref$clientPlacedAds = _ref.clientPlacedAds,
        clientPlacedAds = _ref$clientPlacedAds === undefined ? [] : _ref$clientPlacedAds,
        subtype = _ref.subtype,
        index = _ref.index,
        rest = (0, _objectWithoutProperties3.default)(_ref, ['clientPlacedAds', 'subtype', 'index']);

    var matchingAds = clientPlacedAds.filter(function (ad) {
        return ad.subtype === subtype;
    });
    var adData = matchingAds[index];

    if (adData) {
        return _react2.default.createElement(_Ad2.default, (0, _extends3.default)({}, rest, {
            variants: adData.variants,
            subtype: subtype
        }));
    }

    return null;
};

ClientPlacedAd.defaultProps = {
    index: 0
};

ClientPlacedAd.propTypes = {
    clientPlacedAds: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    subtype: _propTypes2.default.string.isRequired,
    index: _propTypes2.default.number
};

exports.default = ClientPlacedAd;
//# sourceMappingURL=ClientPlacedAd.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-components/lib/ClientPlacedAd/ClientPlacedAd.js
 ** module id = 458
 ** module chunks = 1
 **/